import { LuSearch, BsThreeDots } from "@/Components/Icons/Icons.jsx";

export default { 
row1:  [
  {
    column: "column1",
    columnWidth: "65%",
    rows: {
      row1: [
        {
          name: "exportShipmentStuffingGoodsStuffedAt",
          label: "Goods Stuffed At",
          component: "dropdown",
          width: "69%",
          options: [
            { label: "Dock", value: "Dock" },
            { label: "Factory", value: "Factory" },
          ],
          placeholder: "Factory",
          endIconName: "LuChevronDown",
          iconColor: "gray-400",
          value : "Dock",
        },
        {
          name: "exportShipmentStuffingSampleAccompained",
          checkboxLabel: "Sample Accompained",
          component: "checkboxbox",
          sx: {
            mt: 3.5,
          },
        },
      ],
      row2: [
        {
          name: "exportShipmentStuffingCFS",
          label: "CFS",
          component: "text-field",
          width: "69%",
          icon: LuSearch,
          iconColor: "gray-400",
          type: "autocomplete",
          endpoint: "getCFS",
          disabled:true
   
         
        },
      ],
      row3: [
          {
          name: "exportShipmentStuffingFactoryAddress",
          actionText: "Factory Address",
          component: "Textarea",
          height: 100,
          width: "90%",
          disabled: true,
          dependsOn : "exportShipmentStuffingGoodsStuffedAt",
          dependsOnValue :[ "Factory"],
        },
        // {
        //   name: "Factory Address",
        //   component: "outlinebutton",
        //   height: "45px",
        //   sx: {
        //     mt: "55px",
        //   },
        //   width: "10%",
        //   iconName: BsThreeDots,
        //   iconPosition: "start",
        //   iconSpacing: 0,
        // },
      ],
      row4: [
        {
          name: "exportShipmentStuffingWarehouseCode",
          label: "Warehouse Code (of CFS/ICD/Terminal)",
          component: "text-field",
          width: "69%",
         
        },
      ],
      row5: [
        {
          name: "exportShipmentStuffingSealType",
          label: "Seal Type",
          component: "dropdown",
          width: "69%",
          options: [
            { label: "Agent Seal", value: "Seal" },
            { label: "Self Seal", value: "Self Seal" },
            { label: "Warehouse", value: "Warehouse" },
          ],
          placeholder: "Warehouse",
          endIconName: "LuChevronDown",
          iconColor: "gray-400",
        },
      ],

      row6: [
        {
          name: "exportShipmentStuffingSealNo",
          label: "Seal No",
          component: "text-field",
          width: "69%",
        },
      ],

      row7: [
        {
          name: "exportShipmentStuffingAgencyName",
          label: "Agency Name",
          component: "text-field",
          width: "69%",
        },
      ],
    },
  },
]
}

